import { render } from "./FaireTestQCM.vue?vue&type=template&id=59e48cc8&scoped=true&ts=true"
import script from "./FaireTestQCM.vue?vue&type=script&lang=ts"
export * from "./FaireTestQCM.vue?vue&type=script&lang=ts"

import "./FaireTestQCM.vue?vue&type=style&index=0&id=59e48cc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59e48cc8"]])

export default __exports__